import { EntitySelectEntity } from '@factorialco/f0-react/dist/experimental'
import { LegalEntityForSelectFragment } from 'generated/resources/graphql'

export function mapToFinanceLegalEntitySelectorFragment(
  selected: EntitySelectEntity,
  available: LegalEntityForSelectFragment[]
): LegalEntityForSelectFragment {
  const entity = available.find((a) => a.id === selected.id)

  // This should never happen
  if (!entity) {
    throw new Error('Legal entity not found')
  }

  return entity
}

export function mapToEntitySelectEntity(
  legalEntities: LegalEntityForSelectFragment[],
  showCurrency?: boolean
): EntitySelectEntity[] {
  return legalEntities.map((element) => {
    const displayName = showCurrency
      ? `${element.legalName} - [${element.currency}]`
      : element.legalName || ''

    return {
      id: String(element.id),
      name: displayName,
      searchKey: [element.legalName || ''],
    }
  })
}
